export default __webpack_public_path__ + "static/media/medal_award.e65015f6.jpg";